module.exports = __webpack_public_path__ + "static/media/sidebar-rmks-link.eb151961.png";